export const getProductContractsOfCertainPOTType = (contracts, potType) => {
    let contractsInfo = [];
    if (contracts && Array.isArray(contracts)) {
      contracts.forEach((contract) => {
        const { terms } = contract;
        if (terms && Array.isArray(terms)) {
          const filteredTermsByPotType = terms.filter(
            term => term.tipoTermino === potType
          );
          contractsInfo = [...contractsInfo, filteredTermsByPotType];
        }
      });
    }
    return contractsInfo;
  };